// Sports Nutrition Engine — Auth context (access code based)
import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext({
  accessCode: null,
  setAccessCode: () => {},
  signOut: () => {},
  serviceMode: false,
  setServiceMode: () => {},
});

export const AuthProvider = ({ children }) => {
  const [accessCode, setAccessCodeState] = useState(() => localStorage.getItem("sne_access_code"));
  const [serviceMode, setServiceModeState] = useState(() => localStorage.getItem("sne_service_mode") === "1");
  const setAccessCode = (code) => {
    if (code) localStorage.setItem("sne_access_code", code);
    setAccessCodeState(code);
  };
  const setServiceMode = (on) => {
    if (on) localStorage.setItem("sne_service_mode", "1");
    else localStorage.removeItem("sne_service_mode");
    setServiceModeState(!!on);
  };
  const signOut = () => {
    localStorage.removeItem("sne_access_code");
    localStorage.removeItem("sne_profile");
    localStorage.removeItem("sne_service_mode");
    // Identity lock is tied to the access code — clear it on full sign-out
    // so the next user can onboard freely. Plan-reset (within same code)
    // does NOT clear it: that is the whole point of the lock.
    localStorage.removeItem("sne_identity_lock");
    setAccessCodeState(null);
    setServiceModeState(false);
  };
  return (
    <AuthContext.Provider value={{ accessCode, setAccessCode, signOut, serviceMode, setServiceMode }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
